module.exports = __webpack_public_path__ + "img/LIGHTING 2 RED.15de458.svg";